(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nala-colors-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.owl-carousel.owl-colors').owlCarousel({
      responsive:{
        0:{ items:3 },
        480:{ items:5 },
        768:{ items:5 },
        980:{ items:6 },
        1200:{ items:8 },
        1500:{ items:10 }
      },
      autoplay : true,
      autoplayTimeout : 5000,
      autoplayHoverPause : false,
      smartSpeed : 200,
      fluidSpeed : 200,
      autoplaySpeed : 200,
      navSpeed : 200,
      dotsSpeed : 200,
      loop : true,
      nav : false,
      navText : ['',''],
      dots : false,
      responsiveRefreshRate : 200,
      slideBy : 1,
      mergeFit : true,
      autoHeight : false,
      mouseDrag : false,
      touchDrag : true
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-contact-gmap"]) return;
  try {
    

  function addMap() {
    const _icon_path = document.getElementById('map').dataset.icon;
    let InforObj = [];
    const bounds = new google.maps.LatLngBounds();
    const _address = { lat: 35.096440, lng: -80.948810 };

    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 12,
      center: _address
    });
    const marker = new google.maps.Marker({
      position: _address,
      icon: _icon_path,
      map: map
    });

    google.maps.event.addListener(map, 'click', function () {
      _closeAllInfo();
    });

    let contentString = '<div class="map-info-window">';

    contentString += '<h3 class="map-title">Headquarters</h3>';
    contentString += '<div class="map-address"><p><strong>World Famous Tattoo Ink</strong></p><p>460 Greenway Industrial Drive, Fort Mill, SC 29708</p><p>Phone: 803-578-9700 | Distribution Only</p><p><a href="/sponsorship-application/">Sponsorship Applicants click here</a></p><p><a href="mailto:info@worldfamoustattooink.com">Info@worldfamoustattooink.com</a></p></div>';

    contentString += '</div>'

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 400
    });

    marker.addListener('click', function () {
      _closeOtherInfo();
      infowindow.open(marker.get('map'), marker);
      InforObj[0] = infowindow;
    });

    function _closeOtherInfo() {
      if (InforObj.length > 0) {
        /* detach the info-window from the marker ... undocumented in the API docs */
        InforObj[0].set("marker", null);
        /* and close it */
        InforObj[0].close();
        /* blank the array */
        InforObj.length = 0;
      }
    }

    function _closeAllInfo() {
      if (InforObj.length > 0) {
        /* detach the info-window from the marker ... undocumented in the API docs */
        InforObj[0].set("marker", null);
        /* and close it */
        InforObj[0].close();
        /* blank the array */
        InforObj.length = 0;
      }
    }
  }

  addMap();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-distributors"]) return;
  try {
    

function addMap() {
  const _icon_path = document.getElementById('map').dataset.icon;
  let InforObj = [];
  const _center = { lat: -25.344, lng: 131.036 };

  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 10,
    center: _center
  });

  const bounds = new google.maps.LatLngBounds();
  const markerEls = document.querySelectorAll('.marker');

  if (!markerEls) {
    return;
  }

  let markersOnMap = [...markerEls].map(function(marker) {

    let _address_data = marker.querySelector('.address-data').innerHTML;

    return {
      placeName: marker.dataset.title,
      address: _address_data,
      LatLng: [
        {
          lat: parseFloat(marker.dataset.lat),
          lng: parseFloat(marker.dataset.lng)
        }
      ]
    }
  })

  google.maps.event.addListener(map, 'click', function () {
    _closeAllInfo();
  });

  function addMarkerInfo() {
    let contentString;

    for(let i = 0; i < markersOnMap.length; i++) {

      // content string:
      contentString = '<div class="map-info-window">';

      if(markersOnMap[i].placeName) {
        contentString += '<h4 class="map-title">' + markersOnMap[i].placeName + '</h4>';
      }
      if(markersOnMap[i].address) {
        contentString += '<div class="map-address">' + markersOnMap[i].address + '</div>';
      }

      contentString += '</div>';

      const marker = new google.maps.Marker({
        position: markersOnMap[i].LatLng[0],
        icon: _icon_path,
        map: map
      });

      const infowindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 400
      });


      marker.addListener('click', function () {
        _closeOtherInfo();
        infowindow.open(marker.get('map'), marker);
        InforObj[0] = infowindow;
      });

        bounds.extend(new google.maps.LatLng(markersOnMap[i].LatLng[0].lat, markersOnMap[i].LatLng[0].lng));
    }

    if (markersOnMap.length > 1) {
      map.fitBounds(bounds);
      map.panToBounds(bounds);
    } else {
      map.setCenter(bounds.getCenter());
    }
  }

  function _closeOtherInfo() {
    if (InforObj.length > 0) {
      /* detach the info-window from the marker ... undocumented in the API docs */
      InforObj[0].set("marker", null);
      /* and close it */
      InforObj[0].close();
      /* blank the array */
      InforObj.length = 0;
    }
  }

  function _closeAllInfo() {
    if (InforObj.length > 0) {
      /* detach the info-window from the marker ... undocumented in the API docs */
      InforObj[0].set("marker", null);
      /* and close it */
      InforObj[0].close();
      /* blank the array */
      InforObj.length = 0;
    }
  }

  addMarkerInfo()
}

addMap()

function findAndMarkUSdistributors() {
  const $distributors = $('.m-distributor-item')

  $distributors.each(function(index, item) {
    const $distributor = $(item);
    const _heading_text = $distributor.find('h3').text()

    const _is_USA = _heading_text === 'ARIZONA:' ||  _heading_text === 'CALIFORNIA:' || _heading_text === 'CONNECTICUT:' || _heading_text === 'FLORIDA:' || _heading_text === 'INDIANA:' || _heading_text === 'MARYLAND:' || _heading_text === 'NEW YORK:' || _heading_text === 'UTAH:';

    const _last_USA_distributor = _heading_text === 'UTAH:';

    if(_is_USA) {
      $distributor.addClass('USA')
    }

    if(_last_USA_distributor) {
    $distributor.addClass('last')
    }

  })
}

function addTopDividerToCountry(country) {
  const $distributors = $('.m-distributor-item')

  $distributors.each(function(index, item) {
    const $distributor = $(item);
    const _heading_text = $distributor.find('h3').text().replace(':', '');

    if(_heading_text === country) {
      $distributor.addClass('l-add-divider');
    }


  })
}

findAndMarkUSdistributors();
addTopDividerToCountry('UNITED KINGDOM');
addTopDividerToCountry('INDONESIA');



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-featured-columns"] && !Shopify.designMode) return;
  try {
    
  $('.m-featured').find('img').on('click', function() {
    const $this = $(this);
    const _href = $this.data('url');

    window.location.href = _href;
  })

  $('.m-featured').find('.cycle-overlay').on('click', function() {
    const $this = $(this);
    const $active_slide = $this.closest('.m-featured').find('img.cycle-slide-active');
    const _href = $active_slide.data('url');

    window.location.href = _href;
  })

  $(function() {
    $('.cycle-slideshow.l-second').cycle('pause')
    $('.cycle-slideshow.l-third').cycle('pause')
  })

    setTimeout(function() {
      $('.cycle-slideshow.l-second').cycle('resume')
    }, 2000)

    setTimeout(function() {
      $('.cycle-slideshow.l-third').cycle('resume')
    }, 4000)



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-home-distributors"] && !Shopify.designMode) return;
  try {
    

$(function() {
  const $distributors = $('#shopify-section-nala-distributors');
  const $distributorsMap = $distributors.find('#map');
  const $homeDistributorsMapPlaceholder = $("#homeDistributorsMap");

  $homeDistributorsMapPlaceholder.append($distributorsMap)
  $distributors.remove();
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-home-pro-team"] && !Shopify.designMode) return;
  try {
    
  $('.m-proteam').find('img').on('click', function() {
    const $this = $(this);
    const _href = $this.data('url');

    window.location.href = _href;
  })

  $(function() {
    $('.cycle-slideshow.l-second').cycle('pause')
    $('.cycle-slideshow.l-third').cycle('pause')
  })

    setTimeout(function() {
      $('.cycle-slideshow.l-second').cycle('resume')
    }, 2000)

    setTimeout(function() {
      $('.cycle-slideshow.l-third').cycle('resume')
    }, 4000)



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-page-parallax"]) return;
  try {
    
var scrolled = $(window).scrollTop()
$('.parallax').each(function(index) {
  var imageSrc = $(this).data('image-src')
  var imageHeight = $(this).data('height')
  $(this).css('background-image','url(' + imageSrc + ')')
  $(this).css('height', imageHeight)

  // Adjust the background position.
  var initY = $(this).offset().top
  var height = $(this).height()
  var diff = scrolled - initY
  var ratio = Math.round((diff / height) * 100)
  $(this).css('background-position','center ' + parseInt(-(ratio * 1.5)) + 'px')
})

function isInViewport(node) {
  // Am I visible? Height and Width are not explicitly necessary in visibility
  // detection, the bottom, right, top and left are the essential checks. If an
  // image is 0x0, it is technically not visible, so it should not be marked as
  // such. That is why either width or height have to be > 0.
  var rect = node.getBoundingClientRect()
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

$(window).scroll(function() {
  var scrolled = $(window).scrollTop()
  $('.parallax').each(function(index, element) {
    var initY = $(this).offset().top
    var height = $(this).height()
    var endY  = initY + $(this).height()

    // Check if the element is in the viewport.
    var visible = isInViewport(this)
    if(visible) {
      var diff = scrolled - initY
      var ratio = Math.round((diff / height) * 100)
      $(this).css('background-position','center ' + parseInt(-(ratio * 1.5)) + 'px')
    }
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-parallax"] && !Shopify.designMode) return;
  try {
    
var scrolled = $(window).scrollTop()
$('.parallax').each(function(index) {
  var imageSrc = $(this).data('image-src')
  var imageHeight = $(this).data('height')
  $(this).css('background-image','url(' + imageSrc + ')')
  $(this).css('height', imageHeight)

  // Adjust the background position.
  var initY = $(this).offset().top
  var height = $(this).height()
  var diff = scrolled - initY
  var ratio = Math.round((diff / height) * 100)
  $(this).css('background-position','center ' + parseInt(-(ratio * 1.5)) + 'px')
})

function isInViewport(node) {
  // Am I visible? Height and Width are not explicitly necessary in visibility
  // detection, the bottom, right, top and left are the essential checks. If an
  // image is 0x0, it is technically not visible, so it should not be marked as
  // such. That is why either width or height have to be > 0.
  var rect = node.getBoundingClientRect()
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

$(window).scroll(function() {
  var scrolled = $(window).scrollTop()
  $('.parallax').each(function(index, element) {
    var initY = $(this).offset().top
    var height = $(this).height()
    var endY  = initY + $(this).height()

    // Check if the element is in the viewport.
    var visible = isInViewport(this)
    if(visible) {
      var diff = scrolled - initY
      var ratio = Math.round((diff / height) * 100)
      $(this).css('background-position','center ' + parseInt(-(ratio * 1.5)) + 'px')
    }
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nala-testimonials"] && !Shopify.designMode) return;
  try {
    
  $('.owl-carousel.owl-testimonials').owlCarousel({
      autoplay: true,
      autoplayTimeout: 5000,
      loop:true,
      margin:10,
      items: 1,
      dots: false,
      animateOut: 'fadeOut'
  })

  } catch(e) { console.error(e); }
})();
})();
